<template>
    <!-- 订单管理/课程票券订单管理 -->
    <div class="order-refund">
        <content-view v-show="$utils.renderWhen(this,'allOrder')">
            <div slot="header">
                <a-tabs :activeKey="activeKey" @change="onChangeActiveKey" type="card">
                    <a-tab-pane :key="1" tab="自营"></a-tab-pane>
                    <a-tab-pane :key="2" tab="抖音美团"></a-tab-pane>
                </a-tabs>
                <a-form :form="formHeader" layout="inline" class="store-one-form">
                    <template v-if="activeKey == 1">
                        <a-form-item label="会员手机号">
                            <a-input placeholder="请输入" v-decorator="['phone']" @pressEnter="search(false)"></a-input>
                        </a-form-item>
                        <a-form-item label="交易订单号">
                            <a-input placeholder="请输入" v-decorator="['tradeNo']" @pressEnter="search(false)"></a-input>
                        </a-form-item>
                        <a-form-item label="交易状态">
                            <a-select allowClear placeholder="请选择" v-decorator="['tradeState']" @select="search(false)">
                                <a-select-option v-for="(item, index) in $utils.payState" :value="index" :key="index">{{item}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="购买类型">
                            <a-select allowClear placeholder="请选择" v-decorator="['category']" @select="search(false)">
                                <a-select-option :key="index" v-for="(item, index) in $utils.category" :value="index">{{item}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="购买途径">
                            <a-select allowClear placeholder="请选择" v-decorator="['platform']" @select="search(false)">
                                <template v-for="(item,index) in $utils.platform">
                                    <a-select-option :key="index" :value="index" v-if="item">{{item}}</a-select-option>
                                </template>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="购买门店">
                            <a-select allowClear placeholder="请选择" v-decorator="['shopId']" @select="search(false)">
                                <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="支付方式">
                            <a-select allowClear placeholder="请选择" v-decorator="['payMode']" @select="search(false)">
                                <template v-for="(item,index) in $utils.payMode">
                                    <a-select-option v-if="item" :key="index" :value="index">{{item}}</a-select-option>
                                </template>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="支付金额">
                            <a-input-group compact >
                                <a-input class="range-input range-input-left" placeholder="最小支付金额" v-decorator="['minPayAmount']" />
                                <a-input style="width: 40px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                                <a-input class="range-input range-input-right" placeholder="最大支付金额" v-decorator="['maxPayAmount']" />
                            </a-input-group>
                        </a-form-item>
                        <a-form-item label="人工确认">
                            <a-select allowClear placeholder="请选择" v-decorator="['isManualPayment']" @select="search(false)">
                                <a-select-option value="true">是</a-select-option>
                                <a-select-option value="false">否</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="下单时间">
                            <a-range-picker
                                style="width:282px"
                                format="YYYY/MM/DD"
                                v-decorator="['orderTime']"
                                @change="search(false)"
                            />
                        </a-form-item>
                        <a-form-item label="支付时间">
                            <a-range-picker
                                style="width:282px"
                                format="YYYY/MM/DD"
                                v-decorator="['payTime']"
                                @change="search(false)"
                            />
                        </a-form-item>
                    </template>
                    <template v-if="activeKey == 2">
                        <a-form-item label="订单ID">
                            <a-input placeholder="请输入" v-decorator="['orderId']" @pressEnter="search(false)"></a-input>
                        </a-form-item>
                        <a-form-item label="三方平台类型">
                            <a-select allowClear placeholder="请选择" v-decorator="['thirdType']" @select="search(false)">
                                <a-select-option value="DY">抖音</a-select-option>
                                <a-select-option value="MT">美团</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="订单类型">
                            <a-select allowClear placeholder="请选择" v-decorator="['orderType']" @select="search(false)">
                                <a-select-option :key="index" v-for="(item, index) in orderTypeDYMT" :value="index">{{item}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="购买门店">
                            <a-select allowClear placeholder="请选择" v-decorator="['shopId']" @select="search(false)">
                                <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="商品名称">
                            <a-input placeholder="请输入" v-decorator="['skuName']" @pressEnter="search(false)"></a-input>
                        </a-form-item>
                        <a-form-item label="订单状态">
                            <a-select allowClear placeholder="请选择" v-decorator="['orderState']" @select="search(false)">
                                <a-select-option v-for="(item, index) in orderStatusDYMT" :value="index" :key="index">{{item}}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </template>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search(false)" class="mr8" type="primary" :loading="t_loading">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <!-- 自营 -->
            <a-card v-if="activeKey == 1" :bordered="false">
                <template slot="extra" v-if="getBtnByAuth('exportAll')">
                    <a-button type="primary" @click="search(true)" :loading="loading">导出excel</a-button>
                    <a-button @click="openExportModal">导出记录</a-button>
                </template>
                <a-table :scroll="{y: 360}" :loading="t_loading" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                    <span slot="myToFixed2" slot-scope="key">{{key | myToFixed2}}</span>
                    <template slot="thousandFormat" slot-scope="key">{{key | thousandFormat}}</template>
                    <span slot="platform" slot-scope="platform,row">{{platform != "收银台" ? platform : row.shopName}}</span>
                    <span slot="category" slot-scope="category">{{category}}</span>
                    <span slot="orderTime" slot-scope="a, row">{{row.orderTime ? row.orderTime : "--"}}</span>
                    <span slot="payTime" slot-scope="a, row">{{row.payTime ? row.payTime : "--"}}</span>
                    <span slot="isManualPayment" slot-scope="a, row">{{row.isManualPayment ? '是' : "否"}}</span>
                    <span slot="recommendName" slot-scope="a, row">{{row.tradeRecommend ? row.tradeRecommend.recommendName ? row.tradeRecommend.recommendName : "--" : "--"}}</span>
                    <span slot="recommendShopName" slot-scope="a, row">{{row.tradeRecommend ? row.tradeRecommend.recommendShopName ? row.tradeRecommend.recommendShopName : "--" : "--"}}</span>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('allOrderDetail')">
                                <!-- 跳转到票券订单详情 -->
                            <router-link class="text-primary" :to="{name:'buyOrder', params: {orderId: row.tradeNo}}">查看</router-link>
                            <a-divider type="vertical"/>
                        </span>
                        <span v-if="getBtnByAuth('orderRefund')">
                            <template v-if="row.platformName == '第三方购买' && row.categoryEn == 'Buy' && row.isCanOpenRefund">
                                <a-popconfirm
                                    title="请核对该订单是否已经完成客诉退款，退款成功的情况下，点击确定按钮，会将交易状态修改为“全部退款“，该订单下所有的票券都将变为禁用状态。"
                                    @confirm="confirm(row)"
                                    :overlayStyle="{width: '350px'}"
                                >
                                    <a class="text-primary">OTA客诉</a>
                                </a-popconfirm>
                            </template>
                            <template v-else>
                                <a v-if="row.isCanOpenRefund" class="text-primary" @click="getOrderDetail(row)">退款</a>
                                <span v-if="!row.isCanOpenRefund" class="text-disabled">退款</span>
                            </template>
                        </span>
                    </span>
                </a-table>
            </a-card>
            <!-- 抖音美团 -->
            <a-card v-if="activeKey == 2" :bordered="false">
                <a-table :scroll="{y: 490}" :loading="t_loading" bordered :dataSource="dataSource" :columns="columnsDYMT" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                    <template slot="thirdType" slot-scope="key">{{key ? (key == 'DY' ? '抖音' : '美团') : '--'}}</template>
                    <template slot="shopId" slot-scope="key">{{key ? (shopList.filter(e => e.id == key).length > 0 ? shopList.filter(e => e.id == key)[0].name : '--') : '--'}}</template>
                    <template slot="orderType" slot-scope="key">{{orderTypeDYMT[key]}}</template>
                    <template slot="payAmount" slot-scope="key">{{key ? (key/100).toFixed(2) : '0.00'}}</template>
                    <template slot="orderState" slot-scope="key">{{orderStatusDYMT[key]}}</template>
                    <template slot="payState" slot-scope="key">{{['','未支付','支付成功','支付失败'][key]}}</template>
                    <template slot="refundState" slot-scope="key">{{['未退款','退款中','全部退款','部分退款'][key]}}</template>
                    <template slot="empty" slot-scope="key">{{key || '--'}}</template>
                    <span slot="action" slot-scope="a, row">
                        <template v-if="row.thirdType == 'MT' && ((row.orderType == 0 && row.orderState == 4) || (row.orderType == 2 && row.timesUsed > 0))">
                            <a-popconfirm
                                title="请确认是否撤销该次美团票的核销？"
                                @confirm="reverseMT(row)"
                            >
                                <a class="text-primary">撤销核销</a>
                            </a-popconfirm>
                        </template>
                    </span>
                </a-table>
            </a-card>
            <!-- 退款 -->
            <orderRefund @resetList="getList" ref="orderRefund" :detailData="detailData" :orderData="orderData"></orderRefund>
            <report-export-modal ref="reportExportModal" :exportType="1"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    import orderRefund from "@/components/modules/order/order-refund.component";
    const columns = [
    {
        title: "交易订单号",
        dataIndex: "tradeNo"
    },
    {
        title: "会员手机号",
        dataIndex: "phone"
    },
    {
        title: "购买类型",
        dataIndex: "category",
        scopedSlots: { customRender: "category" }
    },
    {
        title: "购买途径",
        dataIndex: "platformName",
        scopedSlots: { customRender: "platform" }
    },
    {
        title: "交易状态",
        dataIndex: "tradeState",
        scopedSlots: { customRender: "tradeState" }
    },
    {
        title: "订单金额/元",
        dataIndex: "orderAmount",
        scopedSlots: { customRender: "myToFixed2" }
    },
    {
        title: "支付金额/元",
        dataIndex: "payAmount",
        scopedSlots: { customRender: "myToFixed2" }
    },
    {
        title: "订单积分",
        dataIndex: "payPoint",
        scopedSlots: { customRender: "thousandFormat" }
    },
    {
        title: "下单时间",
        dataIndex: "orderTime",
        scopedSlots: { customRender: "orderTime" }
    },
    {
        title: "支付时间",
        dataIndex: "payTime",
        scopedSlots: { customRender: "payTime" }
    },
    {
        title: "是否人工确认",
        dataIndex: "isManualPayment",
        scopedSlots: { customRender: "isManualPayment" }
    },
    {
        title: "业绩人",
        dataIndex: "recommendName",
        scopedSlots: { customRender: "recommendName" }
    },
    {
        title: "业绩门店",
        dataIndex: "recommendShopName",
        scopedSlots: { customRender: "recommendShopName" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" },
        width: 120
    }];
    const columnsDYMT = [
    {
        title: "订单ID",
        dataIndex: "orderId"
    },
    {
        title: "三方平台类型",
        dataIndex: "thirdType",
        scopedSlots: { customRender: "thirdType" }
    },
    {
        title: "购买门店",
        dataIndex: "shopId",
        scopedSlots: { customRender: "shopId" }
    },
    // {
    //     title: "商品ID",
    //     dataIndex: "certificateId",
    // },
    {
        title: "商品名称",
        dataIndex: "skuName",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "商品数量",
        dataIndex: "number",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "商品类型",
        dataIndex: "orderType",
        scopedSlots: { customRender: "orderType" }
    },
    {
        title: "用户ID",
        dataIndex: "userId",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "手机号",
        dataIndex: "mobile",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "订单状态",
        dataIndex: "orderState",
        scopedSlots: { customRender: "orderState" }
    },
    {
        title: "支付状态",
        dataIndex: "payState",
        scopedSlots: { customRender: "payState" }
    },
    {
        title: "退款状态",
        dataIndex: "refundState",
        scopedSlots: { customRender: "refundState" }
    },
    {
        title: "过期时间",
        dataIndex: "receiptEndDate",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "支付金额/元",
        dataIndex: "payAmount",
        scopedSlots: { customRender: "payAmount" }
    },
    {
        title: "支付时间",
        dataIndex: "payTime",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" },
        width: 120
    }]
    export default {
        name: "allOrder",
        components: {
            orderRefund
        },
        props: {},
        data() {
            return {
                columnsDYMT,
                columns,
                dataSource: [],
                shopList: [],
                detailData: {},
                orderData: {},
                total: 0,
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                t_loading: true,
                activeKey: 1,
                orderStatusDYMT: ['','待付款','已支付','未核销','已核销','已关闭'], //1:待付款 2:待发货 3:已发货 4:已完成 5:已关闭
                orderTypeDYMT: ['团购券','周期卡','次卡'],
                // orderStatusDYMT: {'0': '初始化', '100': '待支付', '101': '订单关闭', '200': '支付成功', '201': '待使用', '1': '交易成功'},
                // orderTypeDYMT: {'21': '团购', '31': '预售', '41': '外卖', '90': '外卖', '51': '次卡', '70': '次卡', '60': '券交易'},
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        beforeCreate() {
            this.formHeader = this.$form.createForm(this);
            this.form = this.$form.createForm(this);
        },
        methods: {
            getTab() {
                if(this.activeKey == 1) {
                    this.getList();
                }else if(this.activeKey == 2) {
                    this.dataSource = [];
                    this.pagination.total = 0;
                    this.getOrderDYMT();
                }
            },
            onChangeActiveKey(e) {
                this.activeKey = e;
                this.getTab();
            },
            // 发起OTA退款
            confirm(row) {
                row.orderGoods.forEach(el => {
                    el.applyRefundAmount = el.payAmount;
                    el.businessId = el.userTicketNo;
                });
                this.$api.order.refundOrderList({
                    body: {
                        ...row,
                        category: row.categoryEn,
                        transNo: row.tradeNo,
                        platform: row.platformName,
                        refundMode: 0,
                        reason: 'OTA客诉退款',
                        remarkCategoryCode: 'categoryCode',
                        remarkCategoryName: '客诉补偿',
                        goodsReturn: row.orderGoods,
                        account: row.phone,
                        shopId: this.shopId,
                        verify: 'uncheck',
                    }
                })
                .then(res => {
                    this.getList();
                    this.$message.success('操作成功，可去审核列表查看审核情况')
                })
                .catch(res => {
                    
                })
            },
            // 美团撤销验券
            reverseMT(row) {
                this.$api.order.reverseMT({
                    body: {
                        orderId: row.orderId
                    }
                })
                .then(res => {
                    if(res === false) {
                        this.$message.error('操作失败，核销超过10分钟不能撤销！')
                    }else {
                        this.getOrderDYMT();
                        this.$message.success('操作成功')
                    }
                })
                .catch(res => {
                    
                })
            },
            getOrderDetail(row) {
                if (row.tradeState == "退款中") {
                    this.$message.warn('交易单处于"退款中"，无法继续发起退款');
                    return
                };
                if (this.$moment().day() == 1 || (this.$moment().format('H') < 10 || this.$moment().format('H') >= 23)) {
                    this.$message.warn('当前银联系统收款账户清算中，暂不支持退款。每周一全天和其他日期的23点-次日10点管理后台和小程序都不支持退款。');
                    return
                };
                this.orderData = row;
                this.$api.order.getOrderDetail({
                    body: {
                        transNo: row.tradeNo,
                        transStateStr: row.tradeState
                    }
                }).then(res => {
                    if (!res) {
                        this.detailData = {};
                        return;
                    }
                    this.detailData = res;
                    this.$refs.orderRefund.visibleRefund = true;
                });
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getTab()
            },
            handleReset() {
                this.formHeader.resetFields();
                this.getTab();
            },
            search(isExport) {
                this.pagination.current = 1;
                if(Boolean(isExport)) {
                    this.exportExcel();
                } else {
                    this.getTab();
                }
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    let shopIdList = this.$userInfoTool.getUser().shopIdList;
                    this.shopList = res.filter(i => {
						return shopIdList.find($i => {
							return $i === i.id;
						})
					});
                    if (shopIdList.find(el => el == -1)) {
                        this.shopList = res;
                        this.shopList.unshift({name: '总平台', id: '-1'})
                        return;
                    }
                });
            },
            getOrderDYMT() {
                this.formHeader.validateFields((err, values) => {
                    if (err) return;
                    if(values.orderId && values.orderId.length > 19) {
                        this.$message.warning('订单号不能超过19位，请重新输入')
                        return false
                    }
                    this.t_loading = true
                    this.$api.order.getOrderDYMT({
                        query: Object.assign(values,
                        {
                            offset: this.pagination.current,
                            limit: this.pagination.pageSize,
                        })
                    }).then(res => {
                        try{
                            this.t_loading = false;
                            this.pagination.total = res.total;
                            this.dataSource = res.list || [];
                        }catch (err) {
                            console.log(err);
                        }
                    }).catch(err => {
                        this.t_loading = false;
                    })
                });
            },
            // 获取订单列表
            getList(isExport) {
                this.formHeader.validateFields((err, values) => {
                    if (err) return;
                    if(values.orderId && values.orderId.length > 19) {
                        this.$message.warning('订单号不能超过19位，请重新输入')
                        return false
                    }
                    const orderTime = values['orderTime'] ? values['orderTime'] : []
                    values.minOrderTime = orderTime.length > 0 ? orderTime[0].format('YYYY-MM-DD') : undefined
                    values.maxOrderTime = orderTime.length > 0 ? orderTime[1].format('YYYY-MM-DD') : undefined

                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.minPayTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined
                    values.maxPayTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined

                    delete values.orderTime
                    delete values.payTime
                    this.t_loading = true
                    this.$api.order.orderSearch({
                        query: Object.assign(values,
                        {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            goodsType: "TICKET",
                        })
                    }).then(res => {
                        this.pagination.total = res.total;
                        res.list && res.list.forEach( el => {
                            el.isCanOpenRefund = Boolean(["已支付", "部分退款", "退款中"].find(item => item == el.tradeState)) && Boolean(el.categoryEn == 'Buy' || el.categoryEn == 'GoodsGrant') && Boolean(el.platformName != "积分小程序")
                        })
                        this.dataSource = res.list || [];
                        this.t_loading = false;
                    }).catch(err => {
                        this.t_loading = false;
                    })
                });
            },

            // 导出excel
            exportExcel() {
                this.formHeader.validateFields((err, values) => {
                    if (err) return;
                    if(values.orderId && values.orderId.length > 19) {
                        this.$message.warning('订单号不能超过19位，请重新输入')
                        return false
                    }
                    const orderTime = values['orderTime'] ? values['orderTime'] : []
                    values.minOrderTime = orderTime.length > 0 ? orderTime[0].format('YYYY-MM-DD') : undefined
                    values.maxOrderTime = orderTime.length > 0 ? orderTime[1].format('YYYY-MM-DD') : undefined

                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.minPayTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined
                    values.maxPayTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined
                    delete values.orderTime
                    delete values.payTime
                    this.loading = true
                    this.$api.order.orderExport({
                        query: Object.assign(values,
                        {
                            pageNum: 1,
                            pageSize: this.pagination.total,
                            goodsType: "TICKET"
                        })
                    }).then(res => {
                        this.openExportModal();
                        this.loading = false;

                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            }
        },
        created() {},
        mounted() {
            setTimeout(() => {
                this.getShopList()
                this.getList()
            }, 500);
        },
        watch: {
            '$route'(val) {
                val.name == 'allOrder' && this.getList();
            },
            'shopId'(val) {
                this.activeKey = 1;
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
    .billInfo-refund {
        .red {
            color: rgba(245, 34, 45, 1);
        }
        .border-gray{
            border:1px solid #ddd;
            padding: 16px;
        }
    }
</style>
